import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LazyScrollableDataSource } from '@rappi/common';

import { SelectOption } from '../../../purchase-order-detail/sections/section-base.types';
import { FhOptionResolver } from '../../../shared/fh-select/fh-select.component';
import { CompanyFieldDescriptor, CompanyFormSection, FhFieldState } from '../../company-form.types';

// One card per config section: title, divider, and a two-column grid of fields. Purely
// presentational — visibility and validators are decided by the rules engine in the page and
// handed down through `states`.
@Component({
  selector: 'app-company-form-section',
  templateUrl: './company-form-section.component.html',
  styleUrls: ['./company-form-section.component.scss'],
})
export class CompanyFormSectionComponent {
  /* istanbul ignore next -- decorator metadata */
  @Input() section: CompanyFormSection;
  /* istanbul ignore next -- decorator metadata */
  @Input() form: FormGroup;
  /** controlName -> runtime state. */
  /* istanbul ignore next -- decorator metadata */
  @Input() states: Map<string, FhFieldState> = new Map();
  /* istanbul ignore next -- decorator metadata */
  @Input() submitted = false;
  /** controlName -> remote option source. */
  /* istanbul ignore next -- decorator metadata */
  @Input() sources: Record<string, LazyScrollableDataSource<SelectOption>> = {};
  /** controlName -> resolver for ids the source has not loaded. */
  /* istanbul ignore next -- decorator metadata */
  @Input() resolvers: Record<string, FhOptionResolver> = {};
  /** Fields rendered elsewhere (e.g. test_company lives in the page header). */
  /* istanbul ignore next -- decorator metadata */
  @Input() excludedControlNames: string[] = [];

  /* istanbul ignore next -- decorator metadata */
  @Output() underInputClick = new EventEmitter<CompanyFieldDescriptor>();
  /* istanbul ignore next -- decorator metadata */
  @Output() editOptionClick = new EventEmitter<{ field: CompanyFieldDescriptor; option: SelectOption }>();

  get visibleFields(): CompanyFieldDescriptor[] {
    return (this.section?.fields ?? []).filter(field =>
      this.excludedControlNames.indexOf(field.controlName) === -1
      && !!this.states.get(field.controlName)?.visible
    );
  }

  stateFor(field: CompanyFieldDescriptor): FhFieldState | null {
    return this.states.get(field.controlName) ?? null;
  }

  sourceFor(field: CompanyFieldDescriptor): LazyScrollableDataSource<SelectOption> | null {
    return this.sources[field.controlName] ?? null;
  }

  resolverFor(field: CompanyFieldDescriptor): FhOptionResolver | null {
    return this.resolvers[field.controlName] ?? null;
  }

  trackByControlName(_index: number, field: CompanyFieldDescriptor): string {
    return field.controlName;
  }
}
